import {
  ComputerDesktopIcon,
  WifiIcon,
  VideoCameraIcon,
  MicrophoneIcon,
  SpeakerWaveIcon,
} from '@heroicons/react/24/solid';
import React from 'react';

import ContentWrapper from 'components/ContentWrapper/ContentWrapper';
import DeviceSteps from 'components/DeviceSteps/DeviceSteps';
import Panel from 'components/Panel/Panel';
import { t } from 'locales/i18n';

const DeviceSetup = () => (
  <ContentWrapper title={t('Device Setup')}>
    <Panel panelClassName="mt-6 p-12 space-y-10 flex flex-col text-center">
      <div className="space-y-1">
        <div className="prose-body-lg-med">
          {t(
            'Device setup is a required step for applicants completing video questions.'
          )}
        </div>
        <div className="prose-body-md-reg text-kira-slate-700">
          {t(
            'While this step isn’t configurable, below are the device requirements we ask applicants to meet.'
          )}
        </div>
      </div>
      <div className="flex max-w-5xl flex-wrap justify-center gap-x-8 gap-y-8 self-center lg:flex-row">
        <DeviceSteps
          icon={<ComputerDesktopIcon />}
          title={t('Laptop or desktop computer')}
          description={t('Windows or Mac OS')}
        />
        <DeviceSteps
          icon={<WifiIcon />}
          title={t('Reliable internet')}
          description={t('1 Mbps download/500 Kbps upload')}
        />
        <DeviceSteps
          icon={<MicrophoneIcon />}
          title={t('Microphone')}
          description={t('Built-in or external')}
        />
        <DeviceSteps
          icon={<VideoCameraIcon />}
          title={t('Front-facing camera')}
          description={t('Built-in or external')}
        />
        <DeviceSteps
          icon={<SpeakerWaveIcon />}
          title={t('Speakers')}
          description={t('Built-in or external')}
        />
      </div>
    </Panel>
  </ContentWrapper>
);

export default DeviceSetup;
